import React, { useCallback } from 'react'

import { hooks } from '@front/volcanion'

const withContainer = Component => ({ row, ...props }) => {
  const companycontact_id = _.get(row, 'companycontact_id')
  const [deleteRecord] = hooks.useModelFunction('companycontact', 'delete')
  const onDelete = useCallback(() => deleteRecord({ companycontact_id })
    , [companycontact_id])

  const mergedProps = {
    row,
    onDelete
  }

  return (
    <Component {...mergedProps} {...props} />
  )
}

export default withContainer
